module.exports = __webpack_public_path__ + "img/social-work.57de5ceb.jpg";